import React from "react";
import { Link } from "react-router-dom";
import { LuChevronRight } from "react-icons/lu";

import { useAppSelector } from "../../app/hooks";
import { getLoggingUser } from "../../features/loggingUser/loggingUserSlice";
import {
  appModules,
  getVisibleModules,
  visibleActions,
} from "../../static/modules";
import {
  cardClass,
  cardContentClass,
  cardHeaderClass,
  cardTitleClass,
} from "../ui/styles";

const QuickLinks = () => {
  const loggingUser = useAppSelector(getLoggingUser);

  const isSuperAdmin = !!loggingUser?.roles?.includes("Super Admin");

  const visibleModules = getVisibleModules(
    appModules,
    loggingUser?.permissions,
    isSuperAdmin
  );

  if (visibleModules.length === 0) return null;

  // A module with several actions gets a link per action the user may open.
  const links = visibleModules.flatMap((appModule) =>
    appModule.actions
      ? visibleActions(appModule, loggingUser?.permissions).map((action) => ({
          key: `${appModule.title}-${action.label}`,
          href: action.href,
          icon: appModule.icon,
          title: `${appModule.title} - ${action.label}`,
        }))
      : [
          {
            key: appModule.title,
            href: appModule.href,
            icon: appModule.icon,
            title: appModule.title,
          },
        ]
  );

  return (
    <div className={cardClass}>
      <div className={cardHeaderClass}>
        <div className={`${cardTitleClass} text-lg`}>તમે અહીં જઈ શકો છો</div>
      </div>

      <div className={cardContentClass}>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3">
          {links.map((link) => (
            <Link
              key={link.key}
              to={link.href}
              className="flex items-center gap-3 rounded-md border px-3 py-2.5 transition-colors hover:border-[#34699A] hover:bg-[#34699A]/5"
            >
              <span className="text-lg leading-none">{link.icon}</span>

              <span className="min-w-0 flex-1 truncate text-sm font-medium text-[#113F67]">
                {link.title}
              </span>

              <LuChevronRight className="h-4 w-4 shrink-0 text-[#34699A]" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};
export default QuickLinks;
